import { render, staticRenderFns } from "./Somatometria.vue?vue&type=template&id=7fbe5d30&scoped=true&"
import script from "./Somatometria.vue?vue&type=script&lang=js&"
export * from "./Somatometria.vue?vue&type=script&lang=js&"
import style0 from "./Somatometria.vue?vue&type=style&index=0&id=7fbe5d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe5d30",
  null
  
)

export default component.exports